import React from "react";
import { AlertCenter } from "../classes/AlertCenter";

const alertContextInitial: AlertCenter = {
  ruleModuleAlerts: {},
  ruleItemAlerts: {},
} as AlertCenter;

export const AlertContext = React.createContext<AlertCenter>(
  alertContextInitial
);
